module.exports = __webpack_public_path__ + "static/media/globe.a09bc1e4.svg";